import { site } from "@/lib/seo";
import type { SchemaOptions } from "./types";

// Helper function to create standard page schema options
export function createPageSchemaOptions(
  pageName: string,
  pageDescription: string,
  path: string,
  options?: {
    keywords?: string[];
    breadcrumbs?: Array<{ name: string; url: string }>;
  }
): SchemaOptions {
  return {
    pageName,
    pageDescription,
    pageUrl: `${site.url}${path}`,
    keywords: options?.keywords || [],
    breadcrumbs: options?.breadcrumbs || [
      { name: "Home", url: site.url },
      { name: pageName, url: `${site.url}${path}` }
    ]
  };
}

// Helper function to create blog post schema options
export function createBlogPostSchemaOptions(
  pageName: string,
  pageDescription: string,
  path: string,
  blogPost: {
    headline: string;
    description: string;
    articleBody?: string;
    image: string;
    datePublished: string;
    dateModified: string;
    author: string;
    genre?: string;
  },
  options?: {
    keywords?: string[];
    breadcrumbs?: Array<{ name: string; url: string }>;
  }
): SchemaOptions {
  return {
    pageName,
    pageDescription,
    pageUrl: `${site.url}${path}`,
    keywords: options?.keywords || [],
    breadcrumbs: options?.breadcrumbs || [
      { name: "Home", url: site.url },
      { name: "Blog", url: `${site.url}/blog` },
      { name: pageName, url: `${site.url}${path}` }
    ],
    blogPost
  };
}

// Common breadcrumb patterns
export const breadcrumbPatterns = {
  home: [{ name: "Home", url: site.url }],
  pricing: [
    { name: "Home", url: site.url },
    { name: "Pricing", url: `${site.url}/pricing` }
  ],
  about: [
    { name: "Home", url: site.url },
    { name: "About", url: `${site.url}/about` }
  ],
  contact: [
    { name: "Home", url: site.url },
    { name: "Contact", url: `${site.url}/contact` }
  ],
  blog: [
    { name: "Home", url: site.url },
    { name: "Blog", url: `${site.url}/blog` }
  ],
  solutions: [
    { name: "Home", url: site.url },
    { name: "Solutions", url: `${site.url}/digital-signage-solution` }
  ],
  learn: [
    { name: "Home", url: site.url },
    { name: "Learn", url: `${site.url}/learn` }
  ]
} as const;

// Common keyword sets
export const keywordSets = {
  general: [
    "digital signage software",
    "digital signage solution",
    "cloud digital signage",
    "digital signage company"
  ],
  pricing: [
    "digital signage pricing",
    "digital signage price",
    "professional digital signage pricing"
  ],
  blog: [
    "digital signage guide",
    "digital signage tutorial",
    "digital signage tips"
  ],
  solutions: [
    "digital menu board software",
    "video wall software",
    "digital signage CMS"
  ]
} as const;
